import { render, staticRenderFns } from "./LifeStyle.vue?vue&type=template&id=545d68d3"
import script from "./LifeStyle.vue?vue&type=script&lang=js"
export * from "./LifeStyle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports